import { useJsonForms, withJsonFormsControlProps } from "@jsonforms/react";
import { useContext, useMemo } from "react";
import { CampaignSetupContext } from "../../../context/CampaignSetupContext";
import RewardAllocationConfig from "../../campaign/RewardAllocationConfig/RewardAllocationConfig";

const RewardAllocationConfigSelect = (props) => {
  const { handleChange, path, data, uischema } = props || {};
  const ctx = useJsonForms();
  const jsonformState = ctx.core.data;

  const {
    campaignState: { outcome, outcomeDefinition },
  } = useContext(CampaignSetupContext);

  const currentConfig = useMemo(() => {
    return data || {};
  }, [data]);

  // Create an outcome object with reward_ids from the JSON form state
  const outcomeWithRewardIds = useMemo(() => {
    const rewardIds = jsonformState?.reward_ids || [];
    return {
      ...outcome,
      outcomeData: {
        ...outcome?.outcomeData,
        reward_ids: rewardIds,
      },
    };
  }, [outcome, jsonformState?.reward_ids]);

  const handleConfigChange = (updatedConfig) => {
    handleChange?.(path, updatedConfig);
  };

  const disabled = uischema?.options?.disabled || false;
  const showDistributionStrategy =
    uischema?.options?.showDistributionStrategy ?? true;
  const showMaxAllocationRule = uischema?.options?.showMaxAllocationRule ?? true;
  const showAddReward = uischema?.options?.showAddReward ?? true;
  const showDeleteReward = uischema?.options?.showDeleteReward ?? true;
  const setAutoPriority = uischema?.options?.setAutoPriority ?? false;

  return (
    <div className="reward-allocation-config-select-wrap">
      <RewardAllocationConfig
        config={currentConfig}
        outcomeDefinition={outcomeDefinition}
        onChange={handleConfigChange}
        disabled={disabled}
        outcome={outcomeWithRewardIds}
        showAddReward={showAddReward}
        showDistributionStrategy={showDistributionStrategy}
        showMaxAllocationRule={showMaxAllocationRule}
        showDeleteReward={showDeleteReward}
        setAutoPriority={setAutoPriority}
      />
    </div>
  );
};

export const RewardAllocationConfigSelectControl = withJsonFormsControlProps(
  RewardAllocationConfigSelect
);
export default RewardAllocationConfigSelect;
